module.exports = __webpack_public_path__ + "img/094-saba island.98d7f4d6.svg";